var map = {
	"./calcs/2018/categories.js": 267,
	"./calcs/2019_01/categories.js": 268,
	"./calcs/2019_06/categories.js": 269,
	"./calcs/2019_08/categories.js": 270,
	"./calcs/2019_08_tax/categories.js": 271,
	"./calcs/2020_01/categories.js": 272
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 397;